<div class="flex flex-row">
  @if (showTenantOnly() === false) {
    <div class="user-info-user-name">
      <strong>{{ user()?.firstname }}</strong>
    </div>
  }

  @if (showTenantOnly() === true) {
    <div
      [class.mt-5]="isCollapsed() === false"
      [class.mt-2]="isCollapsed()"
      class="flex-auto flex flex-row items-center justify-center"
    >
      @if (sidebarImage(); as image) {
        @if (image.icon) {
          <!-- A white tile with an inner margin: many icons are full-bleed and would touch the dark sidebar. -->
          <div class="user-info-tenant-icon flex-initial flex items-center justify-center bg-white rounded-lg p-1.5">
            <hypecast-admin-image
              [customClass]="'object-contain'"
              [height]="'28px'"
              [width]="'28px'"
              [loadingClass]="'hypecast-admin-table__row__column__thumbnail__image-container--loading--45'"
              [src]="image.src"
            />
          </div>
        } @else {
          <div class="flex-initial flex flex-row items-center justify-center">
            <hypecast-admin-image
              [customClass]="isCollapsed() ? 'px-2' : 'p-1'"
              [height]="isCollapsed() ? '36px' : '50px'"
              [width]="isCollapsed() ? '36px' : 'auto'"
              [loadingClass]="'hypecast-admin-table__row__column__thumbnail__image-container--loading--45'"
              [src]="image.src"
            />
          </div>
        }
      } @else if (isCollapsed() === false) {
        <div class="flex-auto text-lg text-white text-center mt-2 user-info-company-name">
          {{ tenant()?.companyName }}
        </div>
      }
    </div>
  }

  @if (showTenantOnly() === false) {
    <div class="flex-initial">
      <button [matMenuTriggerFor]="actions" class="button" mat-mdc-icon-button type="button">
        <mat-icon class="text-black icon" svgIcon="arrow_down" />
      </button>
      <mat-menu #actions="matMenu">
        <button [routerLink]="'/users/' + user()?.id" mat-menu-item>Profile</button>
        <div class="bg-secondary-blue" style="height: 1px; width: 100%"></div>
        <button (click)="logout()" mat-menu-item>Logout</button>
      </mat-menu>
    </div>
  }
</div>

@if (showTenantOnly() === false) {
  <div class="flex flex-row mt-2">
    <div class="flex flex-row text-sm flex-auto items-center hide-on-mobile">
      @for (role of user()?.roles; track role; let last = $last) {
        {{ RoleHelper.GetExtendedRoleByValueOrNull(role)?.displayName }}
        @if (last !== true) {
          ,
        }
      }
    </div>
  </div>
}
